import { gql } from '@apollo/client'

export const GET_SERVICES = gql`
  query GetServices($query: String, $excludeIds: [ID!], $first: Int, $after: String, $last: Int, $before: String) {
    services(query: $query, excludeIds: $excludeIds, first: $first, after: $after, last: $last, before: $before) {
      edges {
        node {
          id
          title
          unit
          price
          position
          cartType
          isFreeService
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
